module.exports = __webpack_public_path__ + "img/award (8).909bc449.jpg";